import { faAngleDown, faSort } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import './index.scss';
const SortFilterDropdown = ({ className = '', _sortBy, sortByName }) => {
	const [dropdownOpen, setOpen] = useState(false);
	const toggle = () => setOpen(!dropdownOpen);



	return (
		<ButtonDropdown className={`sort-filter-dropdown ${className}`} isOpen={dropdownOpen} toggle={toggle}>
			<DropdownToggle caret className='d-inline-flex align-items-center'>
				<span className="left-cell">
					<span className='sort-icon'>
						<FontAwesomeIcon icon={faSort} />
					</span>
					<span className="lbl">
						<span>Sort by:</span>{sortByName}
					</span>
				</span>
				<span className='arw-icon ms-auto'>
					<FontAwesomeIcon icon={faAngleDown} />
				</span>
			</DropdownToggle>
			<DropdownMenu>
				<DropdownItem onClick={() => _sortBy('Name', 'name', '1')}>
					<span className='lbl'>Name</span>
					<span className='desc'>
						<span>-</span>
						Ascending
					</span>
				</DropdownItem>
				<DropdownItem onClick={() => _sortBy('Date', 'createdAt', '-1')}>
					<span className='lbl'>Date</span>
					<span className='desc'>
						<span>-</span>
						Latest
					</span>
				</DropdownItem>
				<DropdownItem onClick={() => _sortBy('Size', 'size_in_byte', '-1')}>
					<span className='lbl'>Size</span>
					<span className='desc'>
						<span>-</span>
						High
					</span>
				</DropdownItem>
				<DropdownItem onClick={() => _sortBy('Priority', 'favorite', '-1')}>
					<span className='lbl'>Priority</span>
					<span className='desc'>
						<span>-</span>
						Latest
					</span>
				</DropdownItem>
			</DropdownMenu>
		</ButtonDropdown>
	);
}

export default SortFilterDropdown;